/**
 * Constants for residential/commercial indicator settings
 * These are shared between the component and tests to ensure consistency
 */

// Setting name for the default residential/commercial behavior
export const RESIDENTIAL_INDICATOR_DEFAULT_BEHAVIOR = 'ResidentialIndicatorDefaultBehavior';

// Setting name for the marketplace fallback behavior
export const RESIDENTIAL_INDICATOR_MARKETPLACE_FALLBACK_BEHAVIOR = 'ResidentialIndicatorMarketplaceFallbackBehavior';

// Constants for indicator values
export const RESIDENTIAL_INDICATOR = 'R';
export const COMMERCIAL_INDICATOR = 'C';
export const MARKETPLACE_INDICATOR = 'M';
